import { LoginType } from '@/constants'
import { Board, Note, User, Wall, Subject } from './classes'

/* TUTORIAL */

export interface TutorialStep {
  title: string
  description: string
  elaboration?: string // further description, might include a warning or special notice to the user
  image?: { src: string; description: string }
}

// ---------------  User -----------------
export interface GroupData {
  _id: string
  name: string
  location: string
}

// ---------------  API -----------------

export enum XHR_REQUEST_TYPE {
  GET = 'GET',
  PUT = 'PUT',
  POST = 'POST',
  DELETE = 'DELETE',
}

export enum XHR_CONTENT_TYPE {
  TEXT = 'text/html',
  JSON = 'application/json',
  MULTIPART = 'multipart/form-data',
  URLENCODED = 'application/x-www-form-urlencoded',
}

// Augment the Error class with message and status
export class HttpException extends Error {
  status: number
  message: string
  constructor(status: number, message: string) {
    super(message)
    this.status = status
    this.message = message
  }
}

export enum APIResponseCode {
  Ok = 200,
  Created = 201,
  Accepted = 200,
  NoContent = 204,

  Found = 302,
  NotModified = 304,

  BadRequest = 400,
  UnAuthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  Gone = 410,
  TooLarge = 413,
}

export interface APIResponse<T> {
  status: APIResponseCode
  error?: HttpException
  errors?: HttpException[]
  dataType: XHR_CONTENT_TYPE
  data: T | null
}

export enum ErrorCode {
  LOGIN = '000',
  USER = '001',
  WALL = '010',
  NOTE = '011',
  SHARING = '012',
  MQTT = '030',
}
export interface IWallPayload {
  permalink: string
  pin?: number
  username: string
}

export interface APIRequestPayload {
  errorCode: ErrorCode
  method: XHR_REQUEST_TYPE
  route: string
  credentials?: boolean
  body?: unknown | string | FormData // | <Other Model Type>
  headers?: Record<string, string>
  query?: Record<string, string>
  contentType?: string
  baseURL?: string
  requiresFeedback?: boolean
}

export interface XHRPayload {
  url: string
  headers: Record<string, string>
  credentials: boolean
  body: string | FormData
  method: XHR_REQUEST_TYPE
}

/* REWORKED CLASSES AND INTERFACES */

export interface Group {
  _id?: string
  originalId: string
  name: string
  platform: PlatformType
  location: string
}

export enum PlatformType {
  CANVAS = 'CANVAS',
  DATAPORTEN = 'DATAPORTEN',
  SAML = 'SAML',
  GOOGLE = 'GOOGLE',
}

export interface ScrapeResult {
  description: string
  image: string
  title: string
  url: string
}

export interface StoreResponse {
  success: boolean
  newWallId?: string
  newNoteId?: string
  error?: Error[] | Error | HttpException[]
}

export interface ExtendedStoreResponse extends StoreResponse {
  body?: Wall | Note | Board | User | Map<string, Note> | Record<string, Board> | ExportResponse | Subject[]
}

export interface ExportResponse {
  url: string
}

export interface FilterEntry {
  id: string // name of the tag, group wall or user
  noteIds: Set<string> // list of notes ids
}

export interface AttributeFilter {
  name: string // filter name: group wall, tag, user
  list: FilterEntry[] // list of entries
}

export interface AuthType {
  label: string
  type: LoginType
  url: string
  serviceName: string
  icon: string
  name: string
}
